import { useEffect } from "react";
import { Route } from "react-router-dom";

import { useLazyQuery } from "@apollo/client";
import TodayIcon from "@material-ui/icons/Today";

import { ApplicationMenuEntry } from ".";
import {
  useUserDispatch,
  useUserState,
  setServiceContestualData,
} from "../context";
import { QUERIES } from "../graphql";
import { Service, ServiceType } from "../graphql/models";
import { ServiceReservationsPage } from "../ui/pages";

export type ServiceCalendarRoute = {
  service: Service;
  routePath: string;
  route: Route;
};

export function useContestualServiceRoutes() {
  const {
    userBuilding,
    userRole,
    serviceCalendarRoutes,
    applicationMenuServiceRoutes,
  } = useUserState();
  const dispatch = useUserDispatch();

  const [fetchServices, { data }] = useLazyQuery(QUERIES.BACKOFFICE_SERVICES, {
    fetchPolicy: "no-cache",
    nextFetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (userRole && fetchServices) {
      fetchServices();
    }
  }, [userBuilding, userRole, fetchServices]);

  useEffect(() => {
    if (data && userRole && dispatch) {
      const services = data.backofficeServices as Service[];

      const calendarRoutes: ServiceCalendarRoute[] = [];
      const calendarMenuItems: ApplicationMenuEntry[] = [];

      for (const service of services) {
        if (service.type === ServiceType.DEFAULT) {
          // Default services have no reservations.
          continue;
        }

        const routeName =
          "/app/" + service.name.toLowerCase().replaceAll(" ", "-");

        calendarMenuItems.push({
          icon: <TodayIcon />,
          label: service.name,
          roles: [userRole],
          route: routeName,
        });
        calendarRoutes.push({
          service: { ...service },
          routePath: routeName,
          route: (
            <Route path={routeName}>
              <ServiceReservationsPage key={routeName} service={service} />
            </Route>
          ),
        });
      }

      setServiceContestualData(
        dispatch,
        [...calendarRoutes],
        [...calendarMenuItems]
      );
    }
  }, [data, userRole, dispatch]);

  return { serviceCalendarRoutes, applicationMenuServiceRoutes };
}
